import pagehead from '@/layout/pagehead.vue'
import pagefoot from '@/layout/pagefoot.vue'
import mineleft from '@/layout/mineleft.vue'

const components={
	install(Vue){
		Vue.component('pagehead',pagehead);
		Vue.component('pagefoot',pagefoot);
		Vue.component('mineleft',mineleft);
	}
}
//判断
if(typeof window !=='undefined' && window.Vue){
	install(window.Vue);
}
 
export default components;